import { configureStore } from '@reduxjs/toolkit';
import { createBrowserHistory } from 'history';
import { combineReducers } from 'redux';

import auth from '../actions/auth/authSlice';
import candidate from '../actions/expert/query/candidate/candidateSlice';
import meeting from '../actions/expert/query/meeting/meetingSlice';
import expertFeedbackQueries from '../actions/expert/query/queriesSlice';
import submission from '../actions/expert/query/submission/submissionSlice';
import jobs from '../actions/hiringManager/jobs/jobsSlice';
import jobManagement from '../actions/hiringManager/JobManagement/jobManagementSlice';
import campaignReducer from '../actions/campaign/campaignSlice';

export const history = createBrowserHistory();

const appReducer = combineReducers({
    auth,
    submission,
    candidate,
    meeting,
    expertFeedbackQueries,
    jobs,
    jobManagement,
    campaign: campaignReducer,
});

const rootReducer = (state: any, action: any) => {
    if (action.type === 'auth/logout') return appReducer(undefined, action);
    return appReducer(state, action);
};

const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => [...getDefaultMiddleware()],
});

export default store;
export type RootState = ReturnType<typeof rootReducer>
